<template>
  <div class="row sp-px-24" v-if="items">
    <a v-for="(item, index) in items" :key="index" :href="`/items/${item.slug}`" class="col-lg-4 col-md-6 col-sm-12 mb-20 card-item" data-aos="flip-left">
      <div class="item-card">
        <div class="wide-screen">
          <img v-lazy="item.thumb" />
        </div>
        <div class="item-card-content">
          <label class="color-dark-gray mb-12 text-normal font-14">{{ item.created_at_label }}</label>
          <div class="mb-20 font-16 color-pink">{{ item.tags_label }}</div>
          <div class="color-black title mb-10">{{ item.title }}</div>
          <div class="brief color-dark-gray">{{ item.content }}</div>
        </div>
        <hr />
        <div class="d-flex align-items-center justify-content-between py-20 px-20">
          <span class="font-18 color-dark-gray">{{ __('閲覧数') }}： {{ item.views }}{{ __('回') }}</span>
          <span class="d-flex align-items-center justify-content-end like color-dark-gray" v-bind:class="{'liked': liked(item)}" @click="(event) => clickLike(event, index)">
            <span class="mr-12 font-18">{{ item.likes.length }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="19" viewBox="0 0 19 19" role="img"><path d="M9.44985848,15.5291774 C9.43911371,15.5362849 9.42782916,15.5449227 9.41715267,15.5553324 L9.44985848,15.5291774 Z M9.44985848,15.5291774 L9.49370677,15.4941118 C9.15422701,15.7147757 10.2318883,15.0314406 10.7297038,14.6971183 C11.5633567,14.1372547 12.3827081,13.5410755 13.1475707,12.9201001 C14.3829188,11.9171478 15.3570936,10.9445466 15.9707237,10.0482572 C16.0768097,9.89330422 16.1713564,9.74160032 16.2509104,9.59910798 C17.0201658,8.17755699 17.2088969,6.78363112 16.7499013,5.65913129 C16.4604017,4.81092573 15.7231445,4.11008901 14.7401472,3.70936139 C13.1379564,3.11266008 11.0475663,3.84092251 9.89976068,5.36430396 L9.50799408,5.8842613 L9.10670536,5.37161711 C7.94954806,3.89335486 6.00516066,3.14638251 4.31830373,3.71958508 C3.36517186,4.00646284 2.65439601,4.72068063 2.23964629,5.77358234 C1.79050315,6.87166888 1.98214559,8.26476279 2.74015555,9.58185512 C2.94777753,9.93163559 3.23221417,10.3090129 3.5869453,10.7089994 C4.17752179,11.3749196 4.94653811,12.0862394 5.85617417,12.8273544 C7.11233096,13.8507929 9.65858244,15.6292133 9.58280954,15.555334 C9.53938013,15.5129899 9.48608859,15.5 9.50042471,15.5 C9.5105974,15.5 9.48275828,15.5074148 9.44985848,15.5291774 Z"></path></svg>
          </span>
        </div>
      </div>
    </a>
    <div v-if="isLoading" class="col-sm-12 my-20 d-flex align-items-center justify-content-center height-80">
      <img src="/imgs/loading-png.gif" style="width: 100%; height: 100%; object-fit: contain;" />
    </div>
  </div>
</template>
 
<script>
  export default {
    props: ['paramItems', 'csrf', 'url', 'userId', 'paramTexts'],
    data() {
      return {
        items: undefined,
        currentPage: 1,
        lastPage: 1,
        isLoading: true,
        device_id: undefined,
        texts: []
      }
    },
    mounted() {
      this.texts = JSON.parse(this.paramTexts)
      this.device_id = window.localStorage.getItem('site_code');
      const data = JSON.parse(this.paramItems)
      this.currentPage = data.current_page
      this.lastPage = data.last_page
      this.items = data.data
      window.addEventListener('scroll', this.handleScroll);
      let self = this
      setTimeout(function() {
        self.isLoading = false
      }, 500)
    },
    methods: {
      __(key) {
        return this.texts[key] ?? '';
      },
      handleScroll(event) {
        if (this.hasMore && ($(window).scrollTop() + $(window).height() >= $(document).height() - 100) && this.isLoading == false) {
          this.isLoading = true
          axios.post(this.url, {
            _token: this.csrf,
            page: this.currentPage + 1
          }).then(response => {
            if (response.data.items) {
              this.items = [...this.items, ...response.data.items.data]
              this.currentPage = response.data.items.current_page
              this.lastPage = response.data.items.last_page
            }
          }).finally(() => {
            this.isLoading = false
          })
        }
      },
      liked(item) {
        return item.likes.filter(item => item.device_id == this.device_id || item.user_id == this.userId).length > 0
      },
      clickLike(event, index) {
        event.preventDefault();
        event.stopPropagation();
        if (this.liked(this.items[index])) {
          this.items[index].likes = this.items[index].likes.filter(item => !(item.device_id == this.device_id || item.user_id == this.userId))
        } else {
          this.items[index].likes.push({
            device_id: this.device_id,
            user_id: this.userId && this.userId != '' ? this.userId : null
          })
        }

        $.post(`/items/${this.items[index].slug}/like`, {
          _token: this.csrf,
          device_id: window.localStorage.getItem('site_code')
        })
      }
    },
    computed: {
      hasMore() {
        return this.currentPage < this.lastPage
      }
    }
  }
</script>
